<template>
  <div>
    <div>
    <j-form-container >
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name"  :placeholder="this.language['ad.must.name']"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="已选广告" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <ad-select v-model="model.adOptions" :multiple="true" ></ad-select>
              <a-button @click="getValue">获取select值</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
      </div>
  </div>
</template>


<script>
import AdSelect from '@/views/zch/AdSelect'

export default {
  name: 'test',
  components: {
    AdSelect
  },
  props: {

  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      confirmLoading: false
      ,
      url: {
        add: "/sys/ad/add",
        edit: "/sys/ad/edit",
        queryById: "/sys/ad/queryById"
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      if (this.language) {
        return {
          name: [
            {required: true, message: this.language['ad.must.name']},
            {min: 2, max: 60, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 60 '+this.language['common.character'], trigger: 'blur'}
          ],
          adPosition: [
            {required: true, message: this.language['ad.must']+this.language['ad.position']+'!'},
          ]
        }
      }
    }

  },
  created() {
    //初始化数据
    this.model.adOptions=[
      "hl0001",
      "yyy",
      "1506096703841812482"
    ]
  },
  methods: {
    getApplicationList() {
      httpAction("/sys/role/getSysBmApplication", "", "get").then((res) => {
        if (res.success) {
          this.applicationList = res.result;
        }
      })
    },
    getValue(){
      console.log("model value:",this.model.adOptions)

    }
  }
}


</script>